import React from 'react';
import {
  FDDialog, FDDialogActions, FDDialogContent,
  FDDialogTitle, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  TaxStrategyItemPlannerNote,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/Sections/TaxSavingsSection/TaxStrategyItemPlannerNote';

export const TaxStrategyItemAdditionalInformationDialog = ({
  itemResource,
  setOpen,
  open,
}) => {
  return (
    <FDDialog closeOnBackdropClick onClose={() => setOpen(false)} open={open} dialogWidth={'md'}>
      <FDDialogTitle value={itemResource.attr('additionalInformationTitle')} {...dataAttrs('tax-strategy-dialog-title')} />
      <FDDialogContent>
        <FDStack direction={'column'} spacing={4}>
          <Richtext value={itemResource.attr('additionalInformationDescription')} richtext {...dataAttrs('tax-strategy-dialog-content')} />
          {
            itemResource.isTruthy('hasNote') ? (
              <TaxStrategyItemPlannerNote itemResource={itemResource} />
            ) : null
          }
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDStack width={'100%'}>
          <FDPrimaryActionButton label="Close" onClick={() => setOpen(false)} alignSelf={'flex-start'} {...dataAttrs('close-button')} />
        </FDStack>
      </FDDialogActions>
    </FDDialog>

  );
};

TaxStrategyItemAdditionalInformationDialog.propTypes = {
  itemResource: PropTypes.instanceOf(fr.Resource).isRequired,
  setOpen: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
